import React, { useState, useEffect } from 'react';
import '../BitsStyles/ContactForm.css';
import logo from '../BitsImages/logoooo12345.jpg';
import { Link } from 'react-router-dom';

const ContactSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    const els = document.querySelectorAll('[data-animate]');
    els.forEach(el => observer.observe(el));
    return () => els.forEach(el => observer.unobserve(el));
  }, []);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    interestedIn: '',
    message: '',
    agreePrivacy: false,
  });

  const [errors, setErrors] = useState({});
  const [result, setResult] = useState('');

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleWhatsAppClick = () => {
    const msg = encodeURIComponent('Hello, how may I help you?');
    window.open(`https://wa.me/919603299266?text=${msg}`, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    else if (!/^[6789]\d{9}$/.test(formData.phone)) newErrors.phone = 'Phone must start with 6–9 and be 10 digits';
    if (!formData.message) newErrors.message = 'Message is required';
    if (!formData.agreePrivacy) newErrors.agreePrivacy = 'You must agree to the privacy policy';

    if (Object.keys(newErrors).length === 0) {
      try {
        setResult('Sending....');
        const payload = new FormData();
        payload.append('access_key', '017080b9-1d21-4076-b2b8-4ea5040869d9');
        payload.append('name', formData.fullName);
        payload.append('email', formData.email);
        payload.append('phone', formData.phone);
        if (formData.interestedIn) payload.append('service', formData.interestedIn);
        payload.append('message', formData.message);

        const response = await fetch('https://api.web3forms.com/submit', { method: 'POST', body: payload });
        const data = await response.json();
        if (data.success) {
          setResult('Form Submitted Successfully');
          setFormData({ fullName: '', email: '', phone: '', interestedIn: '', message: '', agreePrivacy: false });
        } else {
          setResult(data.message);
        }
      } catch {
        setResult('An error occurred. Please try again.');
      }
    }
    setErrors(newErrors);
  };

  return (
    <section className="bodyofcontact" id="contact-form">
      <div className="container">

        {/* ── Form Card ── */}
        <div className="contact-form" data-animate="slideInLeft">
          <h1 className="form-title">Drop a message to us</h1>
          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="We are sincerely pleased to know your full name"
                required
              />
              {errors.fullName && <div className="error">{errors.fullName}</div>}
            </div>

            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="We build a relationship, not interrupt your workflow"
                required
              />
              {errors.email && <div className="error">{errors.email}</div>}
            </div>

            <div className="form-group">
              <label>Phone *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Your phone number"
                required
              />
              {errors.phone && <div className="error">{errors.phone}</div>}
            </div>

            <div className="form-group">
              <label>Interested In</label>
              <select name="interestedIn" value={formData.interestedIn} onChange={handleInputChange}>
                <option value="">Select a service</option>
                <option value="webDev">Web Development</option>
                <option value="mobileApp">Mobile App Development</option>
                <option value="consulting">Consulting</option>
                <option value="support">IT Support</option>
                <option value="billing">Billing Solutions</option>
              </select>
            </div>

            <div className="connect-buttons">
              <Link
                to="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z/data=!3m1!4b1!4m4!3m3!8m2!3d15.1618988!4d76.9384711?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="connect-btn">Reach Us via Google Maps</button>
              </Link>
              <span style={{ color: 'rgba(255,255,255,0.4)', alignSelf: 'center' }}>OR</span>
              <button type="button" className="connect-btn" onClick={handleWhatsAppClick}>
                Connect via WhatsApp
              </button>
            </div>

            <div className="form-group">
              <label>Message *</label>
              <textarea
                rows="4"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Need a requirement solved, let us help."
                style={{ resize: 'none' }}
              ></textarea>
              {errors.message && <div className="error">{errors.message}</div>}
            </div>

            <div className="checkbox-group">
              <input
                type="checkbox"
                id="privacy"
                name="agreePrivacy"
                checked={formData.agreePrivacy}
                onChange={handleInputChange}
              />
              <label htmlFor="privacy">
                I agree to provide information in accordance with Bellary Info Tech Solutions privacy policies.
              </label>
              {errors.agreePrivacy && <div className="error">{errors.agreePrivacy}</div>}
            </div>

            <button type="submit" className="submit-btnn">Submit</button>
          </form>
          {result && (
            <span style={{
              color: result.includes('Successfully') ? '#4ade80' : '#FCA5A5',
              fontWeight: 600,
              display: 'block',
              marginTop: '1rem',
              textAlign: 'center',
            }}>
              {result}
            </span>
          )}
        </div>

        {/* ── Info Card ── */}
        <div className="scheduler">
          <div className="profile">
            <img src={logo} alt="Profile" className="profile-img" />
            <h2 className="meeting-title">Bellary Info Tech Solutions | MEETING &amp; GREETING</h2>
          </div>

          <div className="contact-details">
            <div className="contact-item">
              <i className="bi bi-geo-alt-fill contact-icon"></i>
              <a href="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z" target="_blank" rel="noopener noreferrer">Plot No 7, Ward No 18/21, Kappagal Road, M V Nagar 9th Cross, Bellary 583103</a>
            </div>
            <div className="contact-item">
              <i className="bi bi-telephone-fill contact-icon"></i>
              <a href="tel:+919603299266">+91 9603299266</a>
            </div>
            <div className="contact-item">
              <i className="bi bi-telephone-fill contact-icon"></i>
              <a href="tel:+919703299266">+91 9703299266</a>
            </div>
            <div className="contact-item">
              <i className="bi bi-envelope-fill contact-icon"></i>
              <a href="mailto:info@bellaryinfotech.com">info@bellaryinfotech.com</a>
            </div>
          </div>

          <br />
          <h4 style={{ color: 'white', fontWeight: 700, marginBottom: '0.5rem' }}>Follow Us</h4>
          <div className="social-icons">
            <Link to="https://www.facebook.com/BellaryInfotech" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-facebook"></i>
            </Link>
            <Link to="https://x.com/home?lang=en-in" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-twitter"></i>
            </Link>
            <Link to="https://www.linkedin.com/company/bellary-infotech-solutions" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-linkedin"></i>
            </Link>
            <Link to="https://www.instagram.com/bellary_info_tech25?igsh=bm4wbm9ya3kydGQz" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-instagram"></i>
            </Link>
          </div>

          <div className="quote">"Empowering your IT solutions for a better tomorrow."</div>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;
